export default "__VITE_ASSET__b84fbe90__"